/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function(global) {
  'use strict';

  var previousListControllerCompanies = global.ListControllerCompanies;

  function ListControllerCompanies(options) {
    var options = options || {};
    var $conf;
    var params;

    //Modules
    var filters;
    var list;
    var pagination;
    var breadCrumb;

    var spinner;
    var viewErrorHandler;
    var apiUrl;
    var $btnSeeAll;
    var $taCompanies;
    var $selectSector;
    var securityToken;

    // omniture filters
    var isFilterByCompanyName;
    var isFilterBySector;

    var companyName;
    var industry;


    // PushState
    var enablePushState = false;
    var restoreState = false;

    function init() {
      $conf = options.$conf;
      // DevComment: console.group('Module Initialization: Controller');

      // Init params
      params = $conf.data('request-params');

      // Initialize parameter
      // Set bindings
      // Initialize modules
      options.filtersOptions.callback = filterParam;
      options.filtersOptions.$conf = $conf;
      options.filtersOptions.webapiCompanies = $conf.data('webapi-companies');
      options.filtersOptions.selectedFilters = params;
      filters = new FiltersCompanies(options.filtersOptions);
      apiUrl = $conf.data('webapi-path');
      $btnSeeAll = $('.js-see-all');
      $taCompanies = options.filtersOptions.$bar.find('.js-typeahead');
      $selectSector = options.filtersOptions.$bar.find('.js-sector');
      securityToken = $('.js-companies-api-token input[name="__RequestVerificationToken"]').val();

      pagination = new Pagination({
        $container: options.$paginationContainer,
        callback: filterParam,
        hbtpl: $conf.data('hbtpl-pagination'),
        params: $conf.data('pagination'),
        resources: $conf.data('resources'),
      });

      // This module doesn't need callback so far
      list = new ResultList({
        $container: options.$resultsContainer,
        hbtpl: $conf.data('hbtpl-results'),
      });

      // Init spinner
      spinner = new Spinner({
        $selectSpinner: $('.js-spinner'),
        spinnerState: true
      });

      // Init PushsState
      enablePushState = !!(window.history && history.pushState);

      // Init ViewErrorHandler
      viewErrorHandler = new ViewErrorHandler({
        container: $('.js-viewerrorhandler')
      });

      // Init breadCrumb
      breadCrumb = new BreadCrumb({
        $container: options.$breadCrumbContainer,
        hbtpl: $conf.data('hbtpl-breadcrumb')
      });

      // Area bind company site
      options.$resultsContainer.on('click', '.js-area-bind', function (event) {
        var $area = $(this);
        var $clickTrg = $(event.target);

        if(!$clickTrg.is('a')) {
          window.open($area.data('url'), $area.data('target'));
        }
      });


      // Binding and set initial state
      if (enablePushState) {
          window.onpopstate = handlerPopState;
          if (history.state && (restoreState = !eeGlobal.mqDetector.isMobile()? true: restoreState)) {
              params = history.state;
              restoreState = true;
              makeRequest();
          }
      }

      options.$resultsContainer.on('click', '.js-redirect', function (event) {
        spinner.toggle();
      });


      $btnSeeAll.on('click', function () {
        filterParam('paging', 'all');
      });
    }

    function omniture(filterName) {
      console.log($conf.data("selected-company"));
      s.linkTrackVars = 'events,eVar36';
      s.linkTrackEvents = 'event73';
      s.eVar36 = filterName;
      s.events = 'event73';
      s.tl(true, 'o', 'Resultados empresas');
    }

    function makeRequest() {
      var jxqhr;

      jxqhr = $.ajax({
        method: 'POST',
        headers: { '__RequestVerificationToken': securityToken },
        url: apiUrl,
        data: JSON.stringify(params),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
      });

      spinner.toggle();
      viewErrorHandler.hideMessages();

      jxqhr.done(function (data) {
        eeGlobal.notification.clean();

        // Clean container for results notification custom.
        $('.js-results-Notifications').empty();

        if (data.results.length > 0) {
          // renderListResults(data.results, data.resources);

          // omniture
          if (isFilterByCompanyName) {
            companyName = data.companyName;
            omniture(companyName);
          }

          if (isFilterBySector) {
            industry = data.industry;
            omniture(industry);
          }
        } else {
          // viewErrorHandler.showInfo('No existen resultados para la b\u00FAsqueda.');

          // omniture
          if (isFilterByCompanyName) {
            omniture("filtro vacio por empresa");
          }

          if (isFilterBySector) {
            omniture("filtro vacio por sector");
          }

          eeGlobal.notification.info({
            title: data.resources.resultsNull,
            copy: data.resources.resultsTitleNull.replace("{0}", data.industry),
            $target: $('.js-results-Notifications')
          });
        }

        list.render(data.results, data.resources);
        pagination.update(data.paginationInfo, data.resources);
        breadCrumb.update(data.breadcrumbs);

        spinner.toggle();

        if (enablePushState) {
          setPushState(data);
        }
      });

      jxqhr.fail(function() {
        spinner.toggle();
        viewErrorHandler.showWarning('Error al consultar datos, por favor intente m\u00E1s tarde');
      });
    }

    function renderListResults(results, resources) {
      var $container = $('.result-list');
      var sourceTpl = $('#hbtpl-company-list-result').html();
      var hbTpl = Handlebars.compile(sourceTpl);
      var context;
      var html;
      var entry;

      // TODO: Check for an alternative solution that includes windows resize
      if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 767) {
        $container.empty();
      }

      for (var i=0; i<results.length; i++) {
        entry = null;

        context = results[i];
        context.resources = resources;
        html = hbTpl(context);

        $container.append(html);
      }

      // console.log('nodos: ', $container.children().length);
    }


    function showButtonSeeAll(showButton) {
      if (showButton) {
        $btnSeeAll.show();
      } else {
        $btnSeeAll.hide();
      }
    }

    function filterParam(filterType, paramValue) {
      switch (filterType) {
        case 'companyName':
          isFilterByCompanyName = true;
          isFilterBySector = false;
          // setDefaultParam()
          params.industryId = 0;
          // Update this param()
          // CleanResults()
          // Make request
          params.companyName = paramValue;
          params.pageIndex = 1;
          list.clean();
          showButtonSeeAll(true);
          makeRequest();
          break;
        case 'industryId':
          isFilterByCompanyName = false;
          isFilterBySector = true;
          // setDefaultParam()
          params.companyName = '';
          // Update this param()
          // CleanResult()
          // Make request
          params.industryId = paramValue;
          params.pageIndex = 1;
          list.clean();
          showButtonSeeAll(true);
          makeRequest();
          break;
        case 'paging':
          if (paramValue == 'all') {
            params.pageIndex = 1;
            params.companyName = '';
            params.industryId = 0;
            list.clean();
            filters.clean();
            showButtonSeeAll(false);
            makeRequest();
          }
          break;
        case 'pageNumb':
          params.pageIndex = paramValue;
          makeRequest();
          break;
        case 'resultsByPage':
          params.pageSize = paramValue;
          params.pageIndex = 1;
          makeRequest();
          break;

        default:
          console.warning('default?');
          break;
      }
    }

      // PopState

    function setPushState(data) {
        history.pushState(params, '', data.pushUrl);
    }

    function handlerPopState(event) {
        if (event.state != undefined && event.state != "") {
            params = event.state;
        } else {
            params.companyName = 0;
            params.industryId = 0;
            params.pageIndex = 1;
            params.pageSize = 20;
        }
        restoreState = true;
        makeRequest();
    }
    init();
    /*return {}*/
  }

  ListControllerCompanies.noConflict = function noConflict() {
    global.ListControllerCompanies = previousListControllerCompanies;
    return ListControllerCompanies;
  };

  global.ListControllerCompanies = ListControllerCompanies;
}(this);
